<template>
	<h1>Media</h1>
</template>

<script>
export default {
	name: 'Media',
};
</script>

<style></style>
